import React from 'react';
import './Tooltip.css';

interface TooltipProps {
  children: React.ReactNode;
  text: string;
  position?: 'top' | 'bottom';
}

export const Tooltip: React.FC<TooltipProps> = ({ children, text, position = 'top' }) => (
  <span className={`tooltip-wrap tooltip-wrap--${position}`} data-tooltip={text}>
    {children}
  </span>
);
